import { useLanguage } from "@/i18n/LanguageContext";

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="bg-slate-900 py-12" data-testid="footer">
      <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-8 px-4 sm:px-8 md:flex-row md:items-center">
        <div className="flex items-center gap-3">
          <img src="/logo-mark.png" alt="Norgesconsult logo" className="logo-invert h-12 w-auto object-contain" />
          <div>
            <p className="font-display text-base font-bold uppercase tracking-[0.28em] text-white">Norgesconsult</p>
            <p className="mt-0.5 text-xs text-slate-400">{t("footer.tagline")}</p>
          </div>
        </div>

        <div className="flex flex-col gap-1.5 text-sm text-slate-300" data-testid="footer-contact">
          <a href="mailto:post@norgesconsult.no" data-testid="footer-email" className="transition-colors hover:text-sky-400">
            post@norgesconsult.no
          </a>
          <a href="tel:+4741247400" data-testid="footer-phone" className="transition-colors hover:text-sky-400">
            +47 412 47 400
          </a>
          <span className="font-mono text-xs text-slate-500">www.norgesconsult.no</span>
        </div>
      </div>
      <div className="mx-auto mt-10 max-w-7xl border-t border-white/10 px-4 pt-6 sm:px-8">
        <p className="font-mono text-xs uppercase tracking-widest text-slate-500" data-testid="footer-copyright">
          {t("footer.copyright")}
        </p>
      </div>
    </footer>
  );
};

export default Footer;
